/* eslint-disable @typescript-eslint/no-unused-vars */
import { call, put, takeLatest } from "redux-saga/effects";
import { ApiResponse, ImageUrlData, RemovePayload } from "models";
import brandApi from "api/brand";
import { BrandPayload, BrandSubmitForm, UpdateBrandStatus } from "models/brand";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import brandLocationApi from "api/brandLocationApi";
import { brandLocationActions } from "./brandLocationSlice";
import { BrandList, BrandLocations } from "models/brandLocation";
import BrandLocationAction from "../components/action";

function* getCustomerListData(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(brandLocationApi.getCustomerList);
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(brandLocationActions.getCustomerListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(brandLocationActions.getCustomerListFailed(errorData));
  }
}

function* getBrandLocationList(action: PayloadAction<BrandPayload>) {
  try {
    const response: ApiResponse = yield call(
      brandLocationApi.getBrandsLocationList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(brandLocationActions.getBrandLocationSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(brandLocationActions.getBrandLocationFailed(errorData));
  }
}

function* addBrandLocation(action: PayloadAction<BrandLocations>) {
  try {
    const response: ApiResponse = yield call(
      brandLocationApi.addBrandLocation,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(brandLocationActions.addBrandLocationSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(brandLocationActions.addBrandLocationFailed(errorData));
  }
}

function* updateBrandLocation(action: PayloadAction<BrandLocations>) {
  try {
    const response: ApiResponse = yield call(
      brandLocationApi.updateBrandLocation,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(brandLocationActions.updateBrandLocationSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(brandLocationActions.updateBrandLocationFailed(errorData));
  }
}

function* deleteBrandLocations(action: PayloadAction<RemovePayload>) {
  try {
    const response: ApiResponse = yield call(
      brandLocationApi.deleteBrandLocation,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(brandLocationActions.deleteBrandLocationSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(brandLocationActions.deleteBrandLocationFailed(errorData));
  }
}

function* getBrandList(action: PayloadAction<BrandList>) {
  try {
    const response: ApiResponse = yield call(
      brandLocationApi.brandListApi,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(brandLocationActions.getBrandListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(brandLocationActions.getBrandListFailed(errorData));
  }
}

export default function* brandLocationSaga() {
  yield takeLatest(
    brandLocationActions.getCustomerList.type,
    getCustomerListData
  );
  yield takeLatest(
    brandLocationActions.getBrandLocation.type,
    getBrandLocationList
  );
  yield takeLatest(
    brandLocationActions.addBrandLocation.type,
    addBrandLocation
  );
  yield takeLatest(
    brandLocationActions.updateBrandLocation.type,
    updateBrandLocation
  );
  yield takeLatest(
    brandLocationActions.deleteBrandLocation.type,
    deleteBrandLocations
  );
  yield takeLatest(brandLocationActions.getBrandList.type, getBrandList);
}
